<template>
  <div v-if="componentReady" class="container-wrapper year-page">
    <BackLink
      :to="backRoute"
      :text="backButtonText"
    />

    <section class="container">
      <h1 class="year-page__title">{{ title }}</h1>

      <div class="year-page__years">
        <Cars
          :cars="years"
          @select="onYearSelected"
        />
      </div>
    </section>
  </div>
</template>

<script>
  // Step 2

  import { get } from 'lodash'
  import { mapGetters, mapActions } from 'vuex'
  import BackLink from '@/components/BackLink'
  import Cars from '@/components/Cars/Cars'
  import { DEFAULT_LANG } from '@/helpers/constant'

  export default {
    name: 'YearPage',
    components: {
      BackLink,
      Cars
    },
    data () {
      return {
        backButtonText: '',
        title: '',
        years: [],
        componentReady: false
      }
    },
    computed: {
      ...mapGetters([
        'getModel',
        'getAliasParamCity',
        'getAliasParamDealer'
      ]),
      backRoute () {
        const lang = this.$store.state.currentLang
        const queryLang = lang !== DEFAULT_LANG ? { lang } : {}

        return {
          name: 'model',
          query: {
            city: this.getAliasParamCity || undefined,
            dealer: this.getAliasParamDealer || undefined,
            ...queryLang
          }
        }
      }
    },
    watch: {
      $route (to, from) {
        if (this.componentReady && (from.name === 'modification' && to.name === 'year')) {
          this.modelTextState()
          this.modelIdState()
          this.pushDataToDataLayer({
            page: {
              category: 'tools',
              subCategory: 'maintenance',
              sectionlv1: 'tool',
              sectionlv2: 'maintenance-calculator',
              language: this.$store.state.currentLang
            },
            event: {
              name: 'workflowevent',
              componentName: 'maintenance-calculator',
              componentGroup: 'tools',
              action: 'workflow-step',
              label: 'select-production-year'
            },
            workflow: {
              name: 'maintenance-calculator',
              step: 'select-production-year',
              conversion: '0'
            },
            product: [{
              category: 'cars',
              subCategory: 'new-cars',
              productInfo: {
                productId: this.modelId,
                productName: this.modelText,
                tmeModelId: this.modelId,
                modelName: this.modelText
              }
            }]
          }, true)
        }
      },
      componentReady (v) {
        if (v) {
          this.modelTextState()
          this.modelIdState()
          this.pushDataToDataLayer({
            page: {
              category: 'tools',
              subCategory: 'maintenance',
              sectionlv1: 'tool',
              sectionlv2: 'maintenance-calculator',
              language: this.$store.state.currentLang
            },
            event: {
              name: 'workflowevent',
              componentName: 'maintenance-calculator',
              componentGroup: 'tools',
              action: 'workflow-step',
              label: 'select-production-year'
            },
            workflow: {
              name: 'maintenance-calculator',
              step: 'select-production-year',
              conversion: '0'
            },
            product: [{
              category: 'cars',
              subCategory: 'new-cars',
              productInfo: {
                productId: this.modelId,
                productName: this.modelText,
                tmeModelId: this.modelId,
                modelName: this.modelText
              }
            }]
          }, true)
        }
      }
    },
    async created () {
      const data = await this.fetchYearPageData({ model: this.getModel })
      this._data = Object.assign(this._data, data)

      this.componentReady = true
    },
    methods: {
      ...mapActions(['fetchYearPageData']),
      onYearSelected (year) {
        this.$store.commit('SET_MODEL', {
          modelText: this.modelText,
          modelId: this.modelId
        })

        const lang = this.$store.state.currentLang
        const query = lang !== DEFAULT_LANG ? { lang } : {}

        this.$router.push({
          name: 'modification',
          params: { year },
          query
        })
      },

      modelTextState () {
        this.modelText = get(this, '$store.state.model.modelText', '') || get(this, '_data.toyotaModelName', '')
      },
      modelIdState () {
        this.modelId = get(this, '$store.state.model.modelId', '') || get(this, '_data.toyotaModelId', '')
      },
      pushDataToDataLayer (params = {} || window.tngaDataLayer, pushDataLayer = false) {
        window.dataLayer = window.dataLayer || []
        window.tngaDataLayer = { ...params }

        if (pushDataLayer) window.dataLayer.push({ 'event': 'workflowevent' })
      }
    }
  }
</script>

<style lang="scss">
.year-page {
  &__years {
    margin-top: 75px;

    @include mobile {
      margin-top: 35px;
    }
  }
}
</style>
